/**
 * SPDX-FileCopyrightText: 2026 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

import { loadState } from '@nextcloud/initial-state'

const recognizeApiKey = loadState('photos', 'recognizeApiKey', '') as string
export default recognizeApiKey
